import imageOX from '../resources/images/modules/module_open_explore.png';
import imageComments from '../resources/images/modules/module_comments.png';
import imageUsers from '../resources/images/modules/module_users.png';
import imagePush from '../resources/images/modules/module_push.png';
import imageReport from '../resources/images/modules/module_reports.png';
import imageNews from '../resources/images/modules/module_news.svg';
import imageFirebase from '../resources/images/modules/module_firebase.png';
import imageDynamicLink from '../resources/images/modules/module_dynamic_link.jpeg';
import imageGamification from '../resources/images/modules/module_gamification.jpg';
import imageQuiz from '../resources/images/modules/module_quiz.jpg';
import imageKeycloak from '../resources/images/modules/module_keycloak.jpg';
import {
    green400,
    indigo500,
    blue500,
    blue600,
    purple400,
    amber400,
    red400,
    brown300,
    pink500,
    teal500,
    teal200,
    blueGrey400,
    teal700,
} from 'material-ui/styles/colors';
import i18n from 'i18next';

export const OpenExploreModuleColor = green400;
export const UserModuleColor = purple400;
export const CommentsModuleColor = indigo500;
export const PushModuleColor = blue600;
export const ReportModuleColor = amber400;
export const NewsModuleColor = red400;
export const PageModuleColor = brown300;
export const FirebaseModuleColor = blue500;
export const DynamicLinkModuleColor = pink500;
export const RoadBookModuleColor = teal500;
export const GamificationModuleColor = teal200;
export const QuizModuleColor = blueGrey400;
export const AccessTokenModuleColor = teal700;
export const KeycloakModuleColor = blue600;

const push_configuration_keys = [
    'push_server_id',
    'push_server_key',
    'push_server_token_dev',
    'push_server_token_prod',
];

class ModuleService {
    OPEN_EXPLORE = 'open_explore';
    COMMENTS = 'comment';
    USER = 'user';
    PUSH = 'push';
    REPORT = 'report';
    NEWS = 'news';
    PAGE = 'page';
    FIREBASE = 'firebase';
    DYNAMIC_LINK = 'dynamic_link';
    ROAD_BOOK = 'road_book';
    GAMIFICATION = 'gamification';
    QUIZ = 'quiz';
    ACCESS_TOKEN = 'access_token';
    KEYCLOAK = 'keycloak';

    modules = [
        {
            id: this.OPEN_EXPLORE,
            path: 'openexplore',
            image: imageOX,
            color: OpenExploreModuleColor,
        },
        {
            id: this.COMMENTS,
            path: 'comments',
            image: imageComments,
            color: CommentsModuleColor,
        },
        {
            id: this.USER,
            image: imageUsers,
            color: UserModuleColor,
        },
        {
            id: this.PUSH,
            path: 'push',
            image: imagePush,
            color: PushModuleColor,
        },
        {
            id: this.REPORT,
            path: 'reports',
            image: imageReport,
            color: ReportModuleColor,
        },
        {
            id: this.NEWS,
            path: 'news',
            image: imageNews,
            color: NewsModuleColor,
        },
        {
            id: this.PAGE,
            path: 'pages',
            image: imageNews,
            color: PageModuleColor,
        },
        {
            id: this.FIREBASE,
            image: imageFirebase,
            color: FirebaseModuleColor,
        },
        {
            id: this.DYNAMIC_LINK,
            image: imageDynamicLink,
            color: DynamicLinkModuleColor,
        },
        {
            id: this.ROAD_BOOK,
            path: 'road-books',
            image: imageOX,
            color: RoadBookModuleColor,
        },
        {
            id: this.GAMIFICATION,
            path: 'gamification',
            image: imageGamification,
            color: GamificationModuleColor,
        },
        {
            id: this.QUIZ,
            path: 'quizzes',
            image: imageQuiz,
            color: QuizModuleColor,
        },
        {
            id: this.ACCESS_TOKEN,
            image: imageUsers,
            color: AccessTokenModuleColor,
        },
        {
            id: this.KEYCLOAK,
            image: imageKeycloak,
            color: KeycloakModuleColor,
        },
    ];

    hasModule(app, id) {
        const module = this.getModule(id);

        if (app && module) {
            return app.modules.includes(module.id);
        } else {
            return false;
        }
    }

    isPushModuleConfigured(app) {
        let result = true;
        push_configuration_keys.forEach(key => {
            if (app.configurations[key] === null) {
                result = false;
            }
        });
        return result;
    }

    translatedName(module) {
        return i18n.t('module.' + module.id + '.name');
    }

    translatedDesc(module) {
        return i18n.t('module.' + module.id + '.desc');
    }

    translatedNameForId(id) {
        let module = this.getModule(id);

        if (module) {
            return this.translatedName(module);
        }

        return '';
    }

    getModule(id) {
        let filtered = this.modules.filter((module) => {
            return module.id === id;
        });

        if (filtered.length > 0) {
            return filtered[0];
        } else {
            return null;
        }
    }
}

export default new ModuleService();



// WEBPACK FOOTER //
// src/services/module.js